module.exports = __webpack_public_path__ + "static/media/5_how-do-we-stop-cavity-monsters.b3c3753.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/5_how-do-we-stop-cavity-monsters.mp3
// module id = OUYv
// module chunks = 0